<template>
  <vuestic-widget :headerText="$t(title)">
    <mc-form :model="object">
    <table class="table first-td-padding">
      <thead>
        <tr v-if="alert">
          <td colspan="2">
            <vuestic-alert :type="alert.status">
              <span class="badge badge-pill badge-success" v-if="alert.status === 'success'">Success!</span>
              <span class="badge badge-pill badge-danger" v-else-if="alert.status === 'danger'">Error!</span>
              <span class="badge badge-pill badge-warning" v-else-if="alert.status === 'warning'">Warning!</span>
              <span class="badge badge-pill badge-info" v-else>Info!</span>
              {{ alert.message }}
            </vuestic-alert>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td width="25%"></td>
          <td width="75%"></td>
        </tr>
        <tr
          v-if="object !== undefined"
          v-for="(field, fieldName) in object.manifest">
          <!-- Property -->
          <td class="key">
            {{ field.title }}
            <span class="text-danger" v-if="field.required">*</span>
          </td>
          <!-- Value -->
          <td class="value">
            <div class="col-md-6 offset-3 form-group with-icon-right">
              <span v-if="field.type === 'read-only'" class="read-only">
                {{ object[fieldName] }}
              </span>
              <mc-input v-else :field="fieldName" :label="false" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    </mc-form>
    <div class="row actions">
      <div class="col-md-12 text-center submit-row">
        <!--
        <button class="btn btn-default btn-sm" @click="cancel()">
          <div class="btn-with-icon-content">
            <i class="ion-md-close ion"></i>
            CANCEL
          </div>
        </button>
        -->
        <button class="btn btn-success btn-sm" @click="update()">
          SUBMIT
        </button>
      </div>
    </div>
  </vuestic-widget>
</template>

<script>
  import McForm from './form/mc-form'
  import McInput from './form/mc-input'

  export default {
    name: 'mc-edit',
    components: {
      McForm,
      McInput
    },
    props: {
      title: String,
      object: Object,
      alert: [Boolean, Object]
    },
    methods: {
      cancel () {
        this.object.reset()
        this.$emit('cancel')
      },
      update () {
        event.preventDefault()
        this.$emit('update')
      }
    }
  }
</script>

<style>
  td.key {
    text-transform: uppercase;
    font-weight: 500;
  }

  .object-table th, .object-table td {
    min-width: 120px;
    padding: 10px 20px;
  }

  .table-responsive {
    overflow: visible;
  }

  .read-only {
    font-style: italic;
    color: #999;
    position: relative;
    top: 5px;
  }

  .form-group input,
  .form-group textarea {
    color: #AAA;
  }
  .row.actions {
    margin-bottom: 30px;
  }

  .submit-row {
    padding-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/fractel/components/vue-mc/Edit.vue